module.exports = __webpack_public_path__ + "static/2-8ea8a57b51ecc841dd3bbed816f3b229.jpg";